module.exports = __webpack_public_path__ + "static/media/18ECA17.fae8a6e8.jpg";